import React from 'react';
import PropTypes from 'prop-types';

import Avatar from '@strava/ui/Avatar';

import ActionsStarHighlightedXsmall from '@strava/icons/ActionsStarHighlightedXsmall';
import styles from './index.scss';
import LocationAndTime from '../LocationAndTime';
import SocialShareDropdownActions from '../SocialShareDropdownActions';
import {
  timeAndLocationProps,
  entityOwnerProps
} from '../../../props/feed-prop-types';
import { useFeedEntityContext } from '../../../state/FeedEntityContext';

const EntryHeader = ({
  timeAndLocation,
  entityOwner,
  shareable,
  entityId,
  twitterUrl,
  isBoosted,
  entity
}) => {
  const { entityState } = useFeedEntityContext();

  const { displayImage, name, memberType, profileUrl, type } = entityOwner;
  return (
    <div className={styles.entryHeaderWrapper} data-testid="entry-header">
      <div className={styles.entryHeader}>
        <div className={`${styles.media} ${styles.mediaMiddle}`}>
          <div className={styles.mediaLeft} data-testid="avatar">
            <div className={styles.iconContainer}>
              <Avatar
                data-testid="owner-avatar"
                className={
                  entity === 'GroupActivity'
                    ? styles.groupActivityAvatar
                    : styles.avatar
                }
                src={displayImage}
                type={type}
                name={name}
                href={profileUrl}
                badge={memberType}
                onClick={() => {
                  entityState.trackAnalytics({
                    action: 'click',
                    element: 'profile_picture',
                    properties: { element_source: 'title' }
                  });
                }}
              />
            </div>
          </div>
          <div className={styles.mediaBody} data-testid="name-and-location">
            <a
              href={profileUrl}
              data-testid="owners-name"
              onClick={() =>
                entityState.trackAnalytics({
                  action: 'click',
                  element: 'owner_name'
                })
              }
            >
              {name}
            </a>
            {timeAndLocation && (
              <LocationAndTime
                displayDate={timeAndLocation.displayDate}
                displayDateAtTime={timeAndLocation.displayDateAtTime}
                location={timeAndLocation.location}
                timestampFormat={timeAndLocation.timestampFormat}
              />
            )}
          </div>
          <div
            className={`${styles.mediaActions} ${styles.pending}`}
            data-testid="share"
          >
            {shareable && (
              <SocialShareDropdownActions
                activityId={entityId}
                shareable={shareable}
                twitterUrl={twitterUrl}
              />
            )}
            {isBoosted === true && (
              <div data-testid="boosted">
                <ActionsStarHighlightedXsmall fill="#dfdfe8" />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

EntryHeader.propTypes = {
  timeAndLocation: timeAndLocationProps, // not included in group activity athlete entries
  entityOwner: entityOwnerProps.isRequired,
  entityId: PropTypes.string.isRequired,
  shareable: PropTypes.bool.isRequired,
  twitterUrl: PropTypes.string,
  isBoosted: PropTypes.bool.isRequired,
  entity: PropTypes.string
};

EntryHeader.defaultProps = {
  twitterUrl: '',
  timeAndLocation: null,
  entity: ''
};

export default EntryHeader;
